// extracted by mini-css-extract-plugin
export var fadePop = "SignpostGridParagraph-module--fade-pop--fbe9c";
export var grid = "SignpostGridParagraph-module--grid--4ee91";
export var growHeightIn = "SignpostGridParagraph-module--grow-height-in--4dccc";